/* global $ */
import intl from 'react-intl-universal'

export default ['$timeout', 'hyperlinkService', 'toastr', LinkMenu]

function LinkMenu($timeout, hyperlinkService, toastr) {
  this.$onChanges = (changesObj) => {
    if (changesObj.linkElementBeingEdited) {
      //  the below call leads to popover('show') being called a second time, this is done so that the popover will center itself based on the text (after the link url has been data bound)
      $timeout(() => {
        this.onUrlChanged()
      }, 0)

      this.linkOpensInNewTab = window.org_settings.setAnchorsToBlank
    }
  }

  this.openInNewTab = function() {
    hyperlinkService.openInNewTab(this.urlBeingEdited)
  }

  this.openEditLinkView = () => {
    this.linkEditing = true
    //  ensuring that the textbox width doesn't cause the popover to reposition
    let buttonUrlWidth = $('button.link-url').width()
    if (buttonUrlWidth === 0) {
      buttonUrlWidth = 150
    }
    $('.btn-group input.edit-link-textbox').width(buttonUrlWidth + 17)

    $timeout(() => {
      $('.btn-group input.edit-link-textbox')[0].select()
    }, 0)

    // First time link has following string in it, if we have it empty it
    if (this.urlBeingEdited.indexOf('TEMP-LINK-TEMP') > -1) {
      // TODO Eric: Get off global object
      this.linkOpensInNewTab = window.org_settings.setAnchorsToBlank
    } else {
      this.linkOpensInNewTab =
        this.linkElementBeingEdited.get(0).target === '_blank'
    }
  }

  this.cancelLinkEdit = function() {
    // if URL is left blank, undo the anchor
    if (!this.urlBeingEdited) {
      this.removeLink()
    }

    this.linkEditing = false
  }

  this.saveLink = function() {
    const validUrl = hyperlinkService.getValidUrl(this.urlBeingEdited)

    if (!validUrl) {
      toastr.clear()
      toastr.error(intl.get('linkMenu.saveLink.error'))
      return false
    }

    this.updateLink({
      urlBeingEdited: validUrl,
      linkOpensInNewTab: this.linkOpensInNewTab,
    })

    this.urlBeingEdited = ''
    this.hidePopover()
  }

  this.removeLink = function(event) {
    hyperlinkService.removeLink($('#story-wrapper a.selected-link').get(0))
    this.hidePopover()
  }
}
